import { useMemo } from "react";
import { theme } from "antd";

/**
 * Theme-derived palette for avatars and similar rotating accents.
 */
export function useAvatarPalette(): string[] {
  const { token } = theme.useToken();
  return useMemo(
    () => [
      token.colorPrimary,
      token.colorSuccess,
      token.colorInfo,
      token.colorWarning,
      token.colorError,
      token.colorPrimaryActive,
    ],
    [
      token.colorPrimary,
      token.colorSuccess,
      token.colorInfo,
      token.colorWarning,
      token.colorError,
      token.colorPrimaryActive,
    ],
  );
}
